module.exports = __webpack_public_path__ + "img/red-growth-icon.90cd3e4e.svg";